import React from 'react'

import './Textarea.css'

export function Textarea(props) {
	return (
		<div className={`field-group${ props?.fluid ? ' fluid' : ''}`}>
			{props.label && <label>{props.label} {props.required ? '*' : ''}</label>}
            <div className={`input-wrapper ${props.error ? 'error' : ''}`}>
			    <textarea className={`${props.className ?? ''} ${props.error ? 'error' : ''}`} {...props}>{props?.value}</textarea>
            </div>
            { props.error && <div className='field--error'>{props.error}</div>}
            { props.note && <div className='field--note'>{props.note}</div>}
		</div>
	)
}
